import { format } from 'date-fns';

export const convertTime12to24 = (time12h = ''): string => {
  const format12hTime = time12h.replace('AM', ' AM').replace('PM', ' PM');
  const [time, modifier] = format12hTime.split(' ');

  const timeParts = time.split(':');
  let [hours] = timeParts;
  const [, minutes] = timeParts;

  if (hours === '12') {
    hours = '00';
  }

  if (modifier === 'PM') {
    hours = `${parseInt(hours, 10) + 12}`;
  }

  return `${hours}:${minutes}`;
};

// Format date to yyyy-MM-dd
export const getFormattedDate = (date: string) => {
  if (!date) {
    return;
  }

  const formatString = 'yyyy-MM-dd';

  return format(new Date(date), formatString);
};
